<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Funções / Processos "
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold items-center"
    >
      <div class="col-2">
        <div>Nome</div>
        <q-input dense outlined v-model="nome" label="Nome" />
      </div>

      <div class="col-2">
        <div>Unidade</div>
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-2">
        <div>Linhas Por Pagina</div>
        <q-select v-model="perPage" :options="perPageOption" dense outlined>
        </q-select>
      </div>
      <div>
        <p></p>
        <q-btn
          no-caps
          color="positive"
          label="Criar Novo"
          icon="add"
          class="q-mt-xs"
          @click="criar"
        />
      </div>
      <div v-if="filtrosAtivos">
        <p></p>
        <q-btn
          no-caps
          color="brand-1"
          label="Limpar Filtros"
          icon="refresh"
          class="q-mt-xs"
          @click="limparFiltros()"
        />
      </div>
    </div>

    <table-GHE
      :perPage="perPage"
      :atualizar="atualizar"
      :limpar="limparBotao"
      @update:filtrar="filtrarTexto = $event"
    />
  </q-page>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";
import { useFilterPersistence } from "../../../../composables/useFilterPersistence";

import TableGHE from "../components/TableGHE.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { TableGHE, ListaUnidadesSelect, PageHeader },
  setup() {
    const $q = useQuasar();
    const unidade = ref();
    const store = useStore();
    const nome = ref("");
    const perPage = ref("15");
    const atualizar = ref(0);
    const limparBotao = ref(0);
    const isLoadingFilters = ref(false);

    const STORAGE_KEY = "processos-funcoes-filtros";

    const {
      salvarFiltros,
      carregarFiltros: carregarFiltrosComposable,
      limparFiltros: limparFiltrosComposable,
      filtrosAtivos: filtrosAtivosComposable,
    } = useFilterPersistence(
      STORAGE_KEY,
      { nome, perPage },
      {
        nome: "",
        perPage: "15",
      }
    );

    const filtrarTexto = ref("");

    const filtrosAtivos = computed(
      () => filtrosAtivosComposable.value || filtrarTexto.value !== ""
    );

    const carregarFiltros = () => {
      carregarFiltrosComposable();
    };

    const limparFiltros = ({ recarregar = true } = {}) => {
      isLoadingFilters.value = true;
      limparFiltrosComposable();
      filtrarTexto.value = "";
      limparBotao.value++;
      isLoadingFilters.value = false;
      if (recarregar) atualizar.value++;
    };

    const criar = async () => {
      if (nome.value == "") {
        $q.notify({
          message: "O campo nome é obrigatório.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("processos/criarFuncao", {
          vendor_id: store.state.org.unidadeData.id,
          funcao: nome.value,
        });

        $q.notify({
          message: "Função criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizar.value++;
        resetarVariaveis();
      } catch (error) {
        $q.notify({
          message: "Erro ao criar função.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetarVariaveis = () => {
      nome.value = "";
    };

    onMounted(() => {
      isLoadingFilters.value = true;
      carregarFiltros();
      isLoadingFilters.value = false;
    });

    watchDebounced(
      () => nome.value,
      () => {
        if (isLoadingFilters.value) return;
        salvarFiltros();
      },
      { debounce: 400 }
    );

    watch(
      () => unidade.value,
      () => {
        if (isLoadingFilters.value) return;
        salvarFiltros();
      }
    );

    watch(
      () => perPage.value,
      () => {
        if (isLoadingFilters.value) return;
        salvarFiltros();
      }
    );

    return {
      criar,
      atualizar,
      limparBotao,
      filtrarTexto,
      nome,
      resetarVariaveis,
      unidade,
      perPageOption: ["10", "30", "50", "100", "200"],
      perPage,
      filtrosAtivos,
      limparFiltros,
    };
  },
};
</script>

<style></style>
